/**
 * Verified expert reviewers shown on /experts and usable as article reviewers.
 *
 * Only add a record once the person, their qualifications and their consent to
 * be listed are verified. Person schema is emitted only for entries here.
 */
export interface ExpertProfile {
  /** Stable slug; also the schema @id fragment (/experts#slug). */
  id: string;
  name: string;
  role: string;
  /** Verified credentials only, e.g. degrees or professional registrations. */
  credentials: string[];
  /**
   * Scope of the work this person contributes to / reviews. Keep this only to
   * what has been verified — do not add areas the person has not covered.
   */
  reviews: string[];
  bio?: string;
  profileUrl?: string;
  /** Date the record was last verified (ISO). */
  verifiedOn: string;
}

// Individual profiles are added only when the team chooses to publish a
// verified profile. Keep this registry empty until that decision is recorded.
export const EXPERTS: ExpertProfile[] = [];

export const expertPersonId = (id: string) => `https://leadxkids.com/experts#${id}`;

export function expertPersonNode(e: ExpertProfile): Record<string, unknown> {
  return {
    "@type": "Person",
    "@id": expertPersonId(e.id),
    name: e.name,
    jobTitle: e.role,
    ...(e.credentials.length ? { hasCredential: e.credentials.map((c) => ({ "@type": "EducationalOccupationalCredential", name: c })) } : {}),
    ...(e.profileUrl ? { sameAs: [e.profileUrl] } : {}),
    ...(e.bio ? { description: e.bio } : {}),
  };
}
